import { useDispatch, useSelector } from "react-redux";
import { enterPage, loginAction, loginData } from "../../stores/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useLogin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const baseUrl = process.env.REACT_APP_BASEURL;
    const { status, error } = useSelector(loginData);

    const [form, setForm] = useState({
        nip: "",
        email: "",
        password: "",
        type: "pegawai",
    });

    const [loginType, setLoginType] = useState("pegawai");

    useEffect(() => {
        dispatch(enterPage());
    }, [dispatch]);

    const handleChange = (e) => {
        const { value, id } = e.target;
        setForm((prev) => ({
            ...prev,
            type: loginType,
            [id]: value,
        }));
    };

    const isFormValid = (form.nip || form.email) && form.password;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid) return;

        try {
            // unwrap() gives direct access to fulfilled payload
            const response = await dispatch(loginAction(form)).unwrap();

            if (response?.data?.status_code === 200) {
                const enable2FA = response.data.data.enable_2fa;

                if (enable2FA) {
                    navigate("/otp-input");
                } else {
                    navigate("/otp-show");
                }
            }
        } catch (err) {
            // error already handled in redux state
            console.error("Login failed:", err);
        }
    };

    const handleChangeLoginType = (type) => {
        setLoginType(type);
        setForm({
            nip: "",
            email: "",
            password: "",
            type,
        });
    };

    return {
        form,
        baseUrl,
        status,
        error,
        loginType,
        handleSubmit,
        handleChange,
        handleChangeLoginType,
    };
};

export default useLogin;
